/**
 * מחרוזת תצוגה קצרה למשך באטרקציה.
 *
 * @param {number|null|undefined} minutes
 * @returns {string}
 */
export function formatAttractionDuration(minutes) {
  if (minutes == null || minutes === "") return "";
  const n = Number(minutes);
  if (!Number.isFinite(n) || n <= 0) return "";

  const m = Math.round(n);

  if (m < 60) {
    return `${m} דק׳`;
  }

  const h = Math.floor(m / 60);
  const rest = m % 60;

  if (rest === 0) {
    if (h === 1) return "שעה";
    return `${h} שעות`;
  }

  if (h === 1) {
    return rest > 0 ? `שעה ו-${rest} דק׳` : "שעה";
  }

  return `${h} שע׳ ${rest} דק׳`;
}
